<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md2>
          <v-text-field
            disabled
            v-model="mycode"
            label="كود الاذن"
          ></v-text-field>
        </v-flex>
        <!-- <v-flex xs12 sm6 md2>
           <v-text-field @keyup.enter="search_client_by_code"  v-model="searchClientCode" label="كودالعميل"  ></v-text-field>
            </v-flex> 
             <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_client"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="أختر العميل"
                    persistent-hint
                    return-object
                    single-line
                    @change="get_all_info"
                ></v-select>
                  </v-flex> -->
        <v-flex xs12 sm6 md4>
          <v-autocomplete
            v-model="select_khazna"
            :items="khazinas"
            item-text="name"
            item-value="id"
            label=" أختر الخزينة "
            persistent-hint
            return-object
            single-line
            @change="get_khazina"
          >
            <template v-slot:append-outer>
              <v-slide-x-reverse-transition mode="out-in">
              </v-slide-x-reverse-transition>
            </template>
          </v-autocomplete>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-text-field v-model="person" label="الشخص المستلم"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            disabled
            v-model="theKhazna.emp_resposible_name"
            label="موظف الخزينة"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            disabled
            v-model="theKhazna.type"
            label="نوع الخزينة"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            disabled
            v-model="theKhazna.rasid"
            label="الرصيد الفعلي"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md3>
          <v-text-field
            disabled
            v-model="rasid_after"
            label="الرصيد بعد العملية"
          ></v-text-field>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-text-field
            disabled
            v-model="arabic"
            label=" المبلغ حروف"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_withdrew">سحب</v-btn>
        </v-flex>
      </v-layout>

      <br />

      <p>مجموع السحب : {{ total }}</p>

      <v-toolbar flat color="white">
        <v-toolbar-title> جميع السحب السابقة</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="البحث"
          single-line
          hide-details
        ></v-text-field>
      </v-toolbar>

      <v-data-table
        :headers="headers2"
        :items="sadads_fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr
            :style="[
              props.item.status === '0'
                ? { 'background-color': '#D4B1B1' }
                : { 'background-color': '#fff' }
            ]"
          >
            <td class="text-xs-right">{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.rasid_before }}</td>
            <td class="text-xs-right">{{ props.item.money }}</td>
            <td class="text-xs-right">{{ props.item.rasid_after }}</td>
            <td class="text-xs-right">{{ props.item.emp_name }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="text-xs-right">
              <v-btn
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_deposit(props.item)"
                >حذف</v-btn
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  khazina_withdrew_all,
  khazinas,
  khazna_fatworas,
  add_withdrew,
  delete_deposit_khazna,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الكود",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " السعر", value: "address", sortable: false, align: "right" },
      { text: " المتبقي", value: "address", sortable: false, align: "right" },
      { text: " حالة السداد", value: "rasid", sortable: false, align: "right" },
      { text: " نوع السداد", value: "rasid", sortable: false, align: "right" },
      {
        text: "تاريخ التسليم",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: "المديونية وقتها ",
        value: "control",
        sortable: false,
        align: "center"
      },
      {
        text: " مبلغ الخصم ",
        value: "control",
        sortable: false,
        align: "center"
      }
    ],
    headers2: [
      { text: "الكود", value: "code", align: "right" },
      {
        text: " الرصيد قبل",
        align: "right",
        value: "rasid_before"
      },
      { text: "المبلغ", value: "money", align: "right" },
      { text: "الرصيد بعد", value: "rasid_after", align: "right" },
      { text: "الموظف", value: "emp_name", align: "right" },
      { text: "التاريخ", value: "created_at", align: "right" },
      { text: "حذف", value: "created_at", align: "right" }
    ],
    select_client: { id: "" },
    select_khazna: { id: "" },
    search: "",
    comment: "",
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    sadads_fatworas: [],
    total: "",
    khazina_fatworas: [],
    clients: [],
    fatworas: [],
    khazinas: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",
    person: "",

    khazna_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      khazina_id: "",
      action: "",
      created_at: ""
    },

    khazina_update: {
      id: "",
      rasid: ""
    },
    ahad: [],
    hundered: []
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    rasid_after() {
      if (this.money != "") {
        return parseFloat(this.theKhazna.rasid) - parseFloat(this.money);
      } else {
        return this.theKhazna.rasid;
      }
    },
    arabic() {
      let ahaad = this.money.substr(this.money.length - 2, 2);
      let maat =
        this.money.length >= 3
          ? this.money.substr(this.money.length - 3, 1)
          : "";
      let alaf =
        this.money.length == 4
          ? this.money.substr(this.money.length - 4, 1)
          : this.money.length == 5
          ? this.money.substr(this.money.length - 5, 2)
          : this.money.length == 6
          ? this.money.substr(this.money.length - 6, 3)
          : 0;

      let first_again;
      let second_again;
      let third_again;
      ahaad == "00" || ahaad == ""
        ? (first_again = "")
        : (first_again = this.ahad[ahaad]);
      maat == "0" || maat == ""
        ? (second_again = "")
        : (second_again = this.hundered[maat] + " و");
      alaf == "0" || alaf == ""
        ? (third_again = "")
        : (third_again = this.ahad[alaf] + " ألفا" + " و");
      let string;
      this.money.length > 0
        ? (string =
            third_again + second_again + first_again + "  جنيها مصريا لا غير")
        : "";
      return string;
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
    this.hundered = {
      1: "مائة",
      2: "مائتان",
      3: "ثلاثة مائة",
      4: "اربعة مائة",
      5: "خمسة مائة",
      6: "ستة مائة",
      7: "سبعة مائة",
      8: "ثمان مائة",
      9: "تسعة مائة"
    };
    this.ahad = {
      1: "واحد",
      2: "اثنان",
      3: "ثلاثة",
      4: "اربعة",
      5: "خمسة",
      6: "ستة",
      7: "سبعة",
      8: "ثمانية",
      9: "تسعة",
      "01": "واحد",
      "02": "اثنان",
      "03": "ثلاثة",
      "04": "اربعة",
      "05": "خمسة",
      "06": "ستة",
      "07": "سبعة",
      "08": "ثمانية",
      "09": "تسعة",
      10: "عشرة",
      11: "احدي عشر",
      12: "اثنا عشر",
      13: "ثلاثة عشر",
      14: "اربعة عشر",
      15: "خمسة عشر",
      16: "ستة عشر",
      17: "سبعة عشر",
      18: "ثمان عشر",
      19: "تسعة عشر",
      20: "عشرون",
      21: " واحد وعشرون",
      22: "اثنان وعشرون",
      23: "ثلاثة وعشرون",
      24: "اربعة وعشرون",
      25: "خمسة وعشرون",
      26: "ستة وعشرون",
      27: "سبعة وعشرون",
      28: "ثمان وعشرون",
      29: "تسعة وعشرون",
      30: "ثلاثون",
      31: "واحد وثلاثون",
      32: "اثنان وثلاثون",
      33: "ثلاثة وثلاثون",
      34: "اربعة وثلاثون",
      35: "خمسة وثلاثون",
      36: "ستة وثلاثون",
      37: "سبعة وثلاثون",
      38: "ثمان وثلاثون ",
      39: "تسعة وثلاثون ",
      40: "اربعون",
      41: "واحد واربعون",
      42: "اثنان واربعون",
      43: "ثلاثة واربعون",
      44: "اربعة واربعون",
      45: "خمسة واربعون",
      46: "ستة واربعون",
      47: "سبعة واربعون",
      48: "ثمان واربعون",
      49: "تسعة واربعون",
      50: "خمسون",
      51: "واحد وخمسون",
      52: "اثنان وخمسون",
      53: "ثلاثة وخمسون",
      54: "اربعة وخمسون",
      55: "خمسة وخمسون",
      56: "ستة وخمسون",
      57: "سبعة وخمسون",
      58: "ثمان وخمسون",
      59: "تسعة وخمسون",
      60: "ستون ",
      61: "واحد وستون",
      62: "اثنان وستون",
      63: "ثلاثة وستون",
      64: "اربعة وستون",
      65: "خمسة وستون",
      66: "ستة وستون",
      67: "سبعة وستون",
      68: "ثمان وستون",
      69: "تسعة وستون",
      70: "سبعون",
      71: "واحد وسبعون",
      72: "اثنان وسبعون",
      73: "ثلاثة وسبعون",
      74: "اربعة وسبعون",
      75: "خمسة وسبعون",
      76: "ستة وسبعون",
      77: "سبعة وسبعون",
      78: "ثمان وسبعون",
      79: "تسعة وسبعون",
      80: "ثمانون",
      81: "واحد وثمانون",
      82: "اثنان وثمانون",
      83: "ثلاثة وثمانون",
      84: "اربعة وثمانون",
      85: "خمسة وثمانون",
      86: "ستة وثمانون",
      87: "سبعة وثمانون",
      88: "ثمان وثمانون",
      89: "تسعة وثمانون",
      90: "تسعون",
      91: "واحد وتسعون",
      92: "اثنان وتسعون",
      93: "ثلاثة وتسعون",
      94: "اربعة وتسعون",
      95: "خمسة وتسعون",
      96: "ستة وتسعون",
      97: "سبعة وتسعون",
      98: "ثمان وتسعون",
      99: "تسعة وتسعون"
    };
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });

      let myUser = JSON.parse(localStorage.getItem("user"));
      khazinas(myUser.branch_id).then(response => {
        this.khazinas = response.data;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });
    },

    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_client = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina_withdrew_all(this.select_khazna.id).then(response => {
        this.theKhazna = response.data.khazina;
        this.sadads_fatworas = response.data.sadads;
        this.pagination.totalItems = response.data.sadads.length;
        this.total = response.data.total;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_withdrew() {
      if (
        this.money != "" &&
        this.select_khazna.id != "" &&
        this.select_khazna.id2 != ""
      ) {
        if (parseFloat(this.money) <= parseFloat(this.select_khazna.rasid)) {
          let myUser = JSON.parse(localStorage.getItem("user"));

          this.khazna_fatwora_table.code = this.mycode;
          this.khazna_fatwora_table.emp_name = myUser.name;
          this.khazna_fatwora_table.rasid_before = this.select_khazna.rasid;
          this.khazna_fatwora_table.money = this.money;
          this.khazna_fatwora_table.rasid_after = parseFloat(this.money);
          this.khazna_fatwora_table.type = "out";
          this.khazna_fatwora_table.action = "withdrew";
          this.khazna_fatwora_table.created_at = this.date2;
          this.khazna_fatwora_table.notes =
            "تم سحب مبلغ بواسطة " +
            myUser.name +
            " الي " +
            this.person +
            " <br /> " +
            this.arabic +
            " <br />" +
            "الشخص المستلم : " +
            this.person;
          this.khazna_fatwora_table.khazina_id = this.select_khazna.id;

          let khazina_fatwora_ = JSON.stringify(this.khazna_fatwora_table);

          this.khazina_update.id = this.select_khazna.id;
          this.khazina_update.rasid = this.money;

          let khazina_ = JSON.stringify(this.khazina_update);

          this.do_deposit(khazina_fatwora_, khazina_);
        } else {
          this.$swal("Error", "الرصيد غير كافي ", "Error");
        }
      }
    },
    do_deposit(khazina_fatwora_, khazina_) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("khazina", khazina_);
      frmData.append("khazina_fatwora", khazina_fatwora_);
      add_withdrew(frmData).then(response => {
        this.$swal.fire({
          position: "top-end",
          type: "success",
          title: "تمت عملية السحب بنجاح",
          showConfirmButton: false,
          timer: 2000
        });
        this.loading = false;

        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", " سحب من خزينة");
        frmData3.append(
          "body",
          " -تم سحب من خزينة  -" +
            this.select_khazna.name +
            "- بواسطة -" +
            myUser.name +
            "- قيمتها -" +
            this.money +
            " -"
        );
        frmData3.append("type", "khazina_withdrew");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = " سحب من خزينة";
            let mybody =
              " -تم سحب من خزينة  -" +
              this.select_khazna.name +
              "- بواسطة -" +
              myUser.name +
              "- قيمتها -" +
              this.money +
              " -";
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
        setInterval(() => {
          this.$router.go(0);
        }, 2000);
      });
    },
    delete_deposit(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.sadads_fatworas.indexOf(item);

          this.loading = true;

          delete_deposit_khazna(item.id).then(response => {
            this.loading = false;
            this.sadads_fatworas.splice(index, 1);
            this.close();
            this.$router.go(0);
          });
        }
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-text-field__slot input {
  text-align: right;
}
.v-input__slot {
  direction: rtl;
}
</style>
